import { render } from "./DeleteListAction.vue?vue&type=template&id=03ff7f78"
import script from "./DeleteListAction.vue?vue&type=script&lang=ts"
export * from "./DeleteListAction.vue?vue&type=script&lang=ts"
script.render = render

export default script